import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { StepperModule } from 'primeng/stepper';
import { PaButtonComponent } from 'src/app/shared/ui-kit/pa-button/pa-button.component';

@Component({
  selector: 'app-stepper-demo-modal',
  standalone: true,
  imports: [NgIf, PaButtonComponent, StepperModule],
  templateUrl: './stepper-demo-modal.component.html',
  styleUrls: ['./stepper-demo-modal.component.scss'],
})
export class StepperDemoModalComponent {
  activeStep = 1;

  readonly totalSteps = 2;

  constructor(private readonly modalCtrl: ModalController) {}

  close(): void {
    this.modalCtrl.dismiss();
  }

  back(): void {
    if (this.activeStep > 1) {
      this.activeStep--;
    }
  }

  next(): void {
    if (this.activeStep < this.totalSteps) {
      this.activeStep++;
    }
  }
}
